import action from './action'
import mutation from './mutation'
import getters from './getters'

export default {
    state : {
        userDetails : {},
        accessToken : '',
        refreshToken : '',
        isUserLoggedIn : false
    },
    actions : action,
    mutations : mutation,
    getters
}